import React from 'react';

import { AttrsHelper } from '../../../sb-helpers/attrs-helper';

import { AttachmentBadgeUtil } from './attachment-badge-util';

export type AttachmentBadgeProps = {
  /** The whole name, extension included: both the label and the tint are read off it. */
  fileName: string;
  name?: string;
};

/**
 * A file's extension in a tinted square, for the places a picture cannot be drawn - a PDF, a Word
 * file, an image the browser cannot decode. The tint says which family it belongs to at a glance,
 * so a list of them reads without being read.
 */
export const AttachmentBadge = ({
  fileName,
  name = 'ATTACHMENT_BADGE',
}: AttachmentBadgeProps) => {
  const extension = AttachmentBadgeUtil.extensionOf({ fileName });
  const kind = AttachmentBadgeUtil.kindOf({ fileName });

  return (
    <div
      className={AttrsHelper.formatClassname(
        'attachment-badge',
        `kind-${kind}`
      )}
      data-test={name}
    >
      {extension}
    </div>
  );
};
